import createView from './SchedulePageNavigationItemView'
import useViewModel from './SchedulePageNavigationItemViewModel'

export default createView(useViewModel)
